/**
 * @generated SignedSource<<82c784933bca89e21c663d55b0303635>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addressQuery$variables = Record<PropertyKey, never>;
export type addressQuery$data = {
  readonly getSurveyAddress: ReadonlyArray<{
    readonly sidoNm: string | null | undefined;
  }>;
};
export type addressQuery = {
  response: addressQuery$data;
  variables: addressQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RefundUserGetSurveyAddressOutput",
    "kind": "LinkedField",
    "name": "getSurveyAddress",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sidoNm",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addressQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addressQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6563b281c445b2341eddee1db5873494",
    "id": null,
    "metadata": {},
    "name": "addressQuery",
    "operationKind": "query",
    "text": "query addressQuery {\n  getSurveyAddress {\n    sidoNm\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa0c3a3a81762bab65b993370278617e";

export default node;
